// extracted by mini-css-extract-plugin
export var buttons = "_ar-0";
export var buttonsActive = "_ar-h";
export var cancelConfirm = "_ar-1";
export var closeButton = "_ar-2";
export var column = "_ar-3";
export var container = "_ar-4";
export var detailHeader = "_ar-6";
export var detailTitle = "_ar-7";
export var detailsContent = "_ar-5";
export var header = "_ar-8";
export var headerWithClose = "_ar-9";
export var icon = "_ar-a";
export var infoIcon = "_ar-c";
export var informationContainer = "_ar-b";
export var sideDrawer = "_ar-d";
export var sideDrawerOpen = "_ar-e";
export var stickyFooter = "_ar-f";
export var typeOption = "_ar-g";